
// import storage from "./libs/SafeStorage";
// import { Configuration as attachmentsConfig, initializeTactful as initializeAttachments } from '@tactful/attachments-sdk-typescript';
// import { config } from "./config";
// const token = storage.get('userToken');
// const apiVersion = config.VUE_APP_WEBCHAT_HOST_URL_API_VERSION;

// export const attachmentsApiConfig = new attachmentsConfig({
//   basePath: config.VUE_APP_ATTACHMENTS_MICRO_HOST_URL,
//   options: {
//     mode: 'cors',
//   }
// });

const cloudinary = require('cloudinary-core').Cloudinary.new(); //ref>> https://github.com/cloudinary/cloudinary_npm/issues/221
cloudinary.config({
  cloud_name: 'tactful',
});
export const Cloudinary = cloudinary;
// export const attachmentsCore = initializeAttachments(attachmentsApiConfig);
